'use client';

/* eslint-disable max-len,react/function-component-definition,import/order,@typescript-eslint/quotes,@typescript-eslint/consistent-type-definitions,@typescript-eslint/naming-convention */

import { ReactNode } from "react";
import { useMonarchData } from "../../../components/ui/organisms/monarch/MonarchResolver";
import { MonarchTestResult } from "./types";

interface MonarchDataConsumerProps<TestResult extends MonarchTestResult> {
    children: (data: TestResult) => ReactNode;
    experimentKey: string; // Require experiment key to identify which experiment data to use
}

/**
 * Consumes data for a specific Monarch experiment and passes it to its children.
 */
export function MonarchDataConsumer<TestResult extends MonarchTestResult>({
                                                                              children,
                                                                              experimentKey,
                                                                          }: MonarchDataConsumerProps<TestResult>) {
    // Get data for the specific experiment directly
    const dataToProvide = useMonarchData<TestResult>(experimentKey);
    if (!dataToProvide) {
        return <>{children({} as TestResult)}</>;
    }

    return <>{children(dataToProvide)}</>;
}
